import { installSongbirdFallbackInterceptor } from "~/utils/songbird-fallback-interceptor";

/**
 * Client-side songbird fallback.
 *
 * The browser talks directly to `songbirdProxy` (i.e. `SONGBIRD_URL + "api/"`),
 * so when the primary backend is unhealthy the browser can hit any of:
 *
 *   - a CORS preflight failure (no response, surfaced as a "Network Error")
 *   - a network-level failure (DNS, TLS, connection reset, timeout)
 *   - an HTTP 502 from an edge/proxy in front of songbird
 *
 * In any of those cases the shared interceptor rewrites the failing request to
 * point at `songbirdFallbackProxy` (the Railway dev deployment by default) and
 * retries once. The fallback base URL is configured via `SONGBIRD_FALLBACK_URL`.
 *
 * The same interceptor is installed on the Nitro server in
 * `server/plugins/songbird-fallback.ts` so that direct page loads (SSR) also
 * benefit from the fallback.
 */
export default defineNuxtPlugin(() => {
	const { songbirdProxy, songbirdFallbackProxy } = useRuntimeConfig().public as {
		songbirdProxy?: string;
		songbirdFallbackProxy?: string;
	};

	installSongbirdFallbackInterceptor({
		primaryBase: songbirdProxy || "",
		fallbackBase: songbirdFallbackProxy || "",
		context: "songbird/client"
	});
});
